import { Outlet } from "react-router-dom";

import Header from "../components/Header";
import Shadow from "../components/Shadow";
import Footer from "../components/Footer";

function Home() {
  return (
    <div>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default Home;
